//Floating button to create a issue ticket

import {
  Fab,
  Modal,
  Box,
  TextField,
  Select,
  MenuItem,
  Button,
  Grid,
  Typography,
  SelectChangeEvent,
  IconButton,
} from '@mui/material';
import axios from 'axios';
import React, { useState, useRef } from 'react';
import {
  SupportTicket,
  SupportTicketFieldsforpopup,
} from '../../../constants/Supportfields';
import { toast } from 'react-toastify';
import { BASEURL } from '../../../constants/Common';
import { Dialog, DialogContent, DialogActions } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useNavigate } from 'react-router-dom';

export default function FloatingButton() {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [selectedFiles, setSelectedFiles] = useState<File[]>([]);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [popupdialogOpen, setpopupDialogOpen] = useState(false);
  const [isSaving, setIsSaving] = useState(false);

  const storedAuthData = localStorage.getItem('authData');
  const user_id = storedAuthData ? parseInt(storedAuthData, 10) : null;
  const fromusername = (localStorage.getItem('username') || '');
  const organizationId = localStorage.getItem('orgid');
  let orgid: any = null;
  const fileInputRef = useRef<HTMLInputElement>(null); // Ref to access the file input

  if (organizationId) {
    orgid = JSON.parse(organizationId);
  } else {
    navigate('/login')
  }

  const sendemail = localStorage.getItem('email');
  let eMail: any = null;

  if (sendemail) {
    eMail = JSON.parse(sendemail);
  } else {
    navigate('/login')
  }

  const [newTicket, setNewTicket] = useState<SupportTicket>({
    issue_id: null,
    issue_status: 'Active',
    user_id: user_id,
    username: fromusername,
    email: eMail,
    org_id: orgid,
    issue_comments: '',
    issue_category: '',
    issue_description: '',
    attachments: null,
    attachments2: null,
    attachments3: null,
    attachments4: null,
    attachments5: null,
    attachments6: null,
  });

  const handleInputChange = (
    event:
      | React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
      | SelectChangeEvent<string>
  ) => {
    const { name, value } = event.target;
    setNewTicket({ ...newTicket, [name]: value });
  };

  const handleFilesChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newFiles = Array.from(event.target.files!) as File[];
    const uniqueFilesToAdd = newFiles.filter(
      (file) =>
        !selectedFiles.some((selectedFile) => selectedFile.name === file.name)
    );

    if (uniqueFilesToAdd.length + selectedFiles.length > 6) {
      toast.error('You can only upload up to 6 files.');
      return;
    }

    setSelectedFiles((prevFiles) => [...prevFiles, ...uniqueFilesToAdd]);
  };

  const handleRemoveFile = (fileName: string) => {
    setSelectedFiles((prevFiles) =>
      prevFiles.filter((file) => file.name !== fileName)
    );

      // Reset file input value to show "No chosen file"
      if (fileInputRef.current) {
        fileInputRef.current.value = ''; // Reset the file input field
      }
  };

  const handleButtonClick = (evt: React.MouseEvent<HTMLButtonElement>) => {
    evt.preventDefault();
    if (selectedFiles.length > 5) {
      toast.error('You can upload a maximum of 6 files.');
    } else {
      document.getElementById('fileInputs')?.click();
    }
  };

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const resetForm = () => {
    setNewTicket({
      issue_id: null,
      issue_status: '',
      user_id: null,
      username: '',
      email: '',
      org_id: orgid,
      issue_comments: '',
      issue_category: '',
      issue_description: '',
      attachments: null,
      attachments2: null,
      attachments3: null,
      attachments4: null,
      attachments5: null,
      attachments6: null,
    });
    setSelectedFiles([]);
  };

  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();
    if (newTicket.issue_category.length === 0) {
      toast.error('Please select category.');
      return;
    }
    if (newTicket.issue_description.length === 0) {
      toast.error('Description is required.');
      return;
    }
    setIsSaving(true);
    try {
      newTicket.attachments = selectedFiles[0];
      newTicket.attachments2 = selectedFiles[1];
      newTicket.attachments3 = selectedFiles[2];
      newTicket.attachments4 = selectedFiles[3];
      newTicket.attachments5 = selectedFiles[4];
      newTicket.attachments6 = selectedFiles[5];

      // console.log('newTicket:', newTicket);
      const url_create = BASEURL + '/issues/create/';
      const response = await axios.post(url_create, newTicket, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });

      setpopupDialogOpen(true);
      if (response?.status === 201) {
        toast.success(response?.data?.message || 'Support ticket created successfully')
      }
      resetForm();
      setIsSaving(false);
      handleClose();
    } catch (error) {
      toast.error('Error creating support ticket');
      setIsSaving(false);
    }
  };

  return (
    <div>
      <Fab
        color='primary'
        aria-label='Need help?'
        sx={{
          position: 'fixed',
          bottom: 16,
          right: 16,
        }}
        onClick={handleOpen}
      >
        Need help?
      </Fab>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby='modal-modal-title'
        aria-describedby='modal-modal-description'
      >
        <Box
          sx={{
            position: 'absolute',
            bottom: 80,
            right: 16,
            width: 600,
            maxHeight: '70vh',
            bgcolor: 'background.paper',
            border: '2px solid #000',
            boxShadow: 24,
            p: 2,
            overflow: 'auto',
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <IconButton
            aria-label='close'
            onClick={handleClose}
            sx={{
              position: 'absolute',
              top: -6,
              left: 551,
            }}
          >
            <CloseIcon />
          </IconButton>
          <form onSubmit={handleSubmit}>
            <Grid container spacing={2} sx={{ mt: "5px" }}>
              {SupportTicketFieldsforpopup.map((field) => (
                <React.Fragment key={field.name}>
                  <Grid item xs={4}>
                    <Typography>
                      <strong>{field.title}</strong>
                    </Typography>
                  </Grid>
                  <Grid item xs={8}>
                    {field.type === 'dropDown' ? (
                      <Select
                        value={
                          newTicket[field.name] !== null
                            ? (newTicket[field.name] as string)
                            : ''
                        }
                        onChange={handleInputChange}
                        sx={{ width: '100%' }}
                        variant='outlined'
                        name={field.name}
                      >
                        {field.options?.map((option, index) => (
                          <MenuItem key={index} value={option}>
                            {option}
                          </MenuItem>
                        ))}
                      </Select>
                    ) : field.type === 'textArea' ? (
                      <TextField
                        name={field.name}
                        value={newTicket[field.name]}
                        onChange={handleInputChange}
                        fullWidth
                        margin='normal'
                        variant='outlined'
                        multiline
                        rows={field.height}
                      />
                    ) : field.name === 'attachments' ? (
                      <Box sx={{ mt: '15px', width: '100%' }}>
                         <Button variant='contained' color='primary' onClick={handleButtonClick}>
                      Browse
                    </Button>
                        {selectedFiles.map((file) => (
                          <div key={file.name}>
                            <Grid mt={1} container spacing={0}>
                              <Grid item xs={10}>
                                <span>{file.name}</span>
                              </Grid>
                              <Grid item xs={2}>
                                <Button
                                  onClick={() => handleRemoveFile(file.name)}
                                  variant='text'
                                  color='error'
                                >
                                  Remove
                                </Button>
                              </Grid>
                            </Grid>
                          </div>
                        ))}
                        <input
                          id='fileInputs'
                          type='file'
                          name='file'
                          ref={fileInputRef} // Reference to the file input
                          onChange={handleFilesChange}
                          accept='.jpg, .jpeg, .png'
                          multiple
                          style={{ display:'none' }}
                        />
                      </Box>
                    ) : (
                      <TextField
                        name={field.name}
                        type={field.type}
                        value={newTicket[field.name]}
                        onChange={handleInputChange}
                        fullWidth
                        margin='normal'
                        variant='outlined'
                        sx={{ width: '100%' }}
                      />
                    )}
                  </Grid>
                </React.Fragment>
              ))}
            </Grid>
            <Box sx={{ textAlign: 'right', mt: 2 }}>
              <Button type='submit' variant='contained' color='primary'
                sx={{ '&:disabled': { bgcolor: 'grey.400', color: 'grey.700' } }} disabled={isSaving}>
                Save
              </Button>
            </Box>
          </form>
        </Box>
      </Modal>
      <Dialog open={popupdialogOpen} onClose={() => setpopupDialogOpen(false)}>
        <DialogContent>
          <Typography variant='body1'>
            Dear User, Thank you for submitting your issue. We'll address it
            promptly.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setpopupDialogOpen(false);
            }}
            variant='contained' color='primary'
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}